"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { getLanguage } from "../../../../../utils/index.js";
import { VideoPlayer } from "@nxt-costco-com/forge-components";
import { SpaceMd } from "@nxt-costco-com/forge-design-tokens";
import { Analytics } from "../../../../Analytics/index.js";
import { VideoSpotlightContainer } from "../styles.js";
import { ProductTileCarouselClient } from "../../ProductTileCarousel/ProductTileCarouselClient.js";
import { AdSetContainerStyles } from "../../styles.js";
import { CostcoBox } from "../../../../Util/CostcoBox.js";
import { useCheckScreen } from "../../../../../hooks/useCheckScreen/index.js";
import { LegalText } from "./LegalText.js";
const VideoSpotlightRail = ({
  contentStackEntry = {},
  locale,
  ParentSKUs,
  productTileSx,
  sx = {},
  testId,
  analytics,
  carouselA11yInformation,
  videoInformation,
  videoBeacons,
  isCriteo = false
}) => {
  var _a;
  const { isTablet, isMobile } = useCheckScreen();
  const {
    product_card_display_style,
    show_reviews,
    show_action_button,
    inventory_aware_listings,
    product_tile_data_source
  } = (contentStackEntry == null ? void 0 : contentStackEntry.product_display_style) || {};
  return /* @__PURE__ */ jsx(
    CostcoBox,
    {
      sx: {
        width: "100%",
        ...AdSetContainerStyles,
        ...sx
      },
      children: /* @__PURE__ */ jsxs(VideoSpotlightContainer, { "data-testid": testId, isMobile, children: [
        /* @__PURE__ */ jsxs(
          CostcoBox,
          {
            sx: {
              borderTopLeftRadius: "10px",
              borderTopRightRadius: "10px",
              overflow: "hidden",
              paddingBottom: "1rem"
            },
            children: [
              /* @__PURE__ */ jsx(
                VideoPlayer,
                {
                  analytics: videoBeacons,
                  controlBarStyles: "justify-content:center",
                  language: getLanguage(locale),
                  options: videoInformation.options
                }
              ),
              videoInformation.legalText && /* @__PURE__ */ jsx(
                LegalText,
                {
                  text: videoInformation.legalText,
                  variant: "rail"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          Analytics,
          {
            analyticData: {
              adItem: {
                style: "carousel",
                title: (_a = contentStackEntry == null ? void 0 : contentStackEntry.ad_set_heading_and_costco_url) == null ? void 0 : _a.title,
                type: "product"
              },
              title: contentStackEntry.title
            },
            children: /* @__PURE__ */ jsx(
              ProductTileCarouselClient,
              {
                containerSx: {
                  marginBottom: 0,
                  maxWidth: isMobile ? "100%" : void 0,
                  padding: !isMobile ? `${SpaceMd}` : void 0
                },
                productTileContainerSx: {
                  alignItems: "center",
                  display: "flex"
                },
                productTileNumberSeparator: carouselA11yInformation.productTileNumberSeparator,
                productTileSx: {
                  ...productTileSx,
                  marginBottom: 0,
                  maxWidth: "224px"
                },
                analytics,
                ariaLabel: carouselA11yInformation.carouselLabel,
                criteoDataSourceAttr: true,
                hideReviewStarValue: true,
                inventoryAware: inventory_aware_listings,
                isHorizontal: false,
                itemNumbers: ParentSKUs,
                locale,
                maxProductTileImageWidth: "224px",
                maxSlides: 1,
                navigationButtonBottomOffset: "70%",
                navigationButtonsBottomAlign: false,
                navigationButtonsMobileDisplay: isMobile,
                pageType: "search",
                productTileMaxLineNumber: 2,
                showActionButton: show_action_button,
                showReviews: show_reviews,
                showSlideNumber: isTablet,
                testId,
                variant: product_card_display_style,
                product_tile_data_source,
                isCriteo
              }
            )
          }
        )
      ] })
    }
  );
};
export {
  VideoSpotlightRail
};
